import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Container, Link, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';

import {
    BookingTypeCard, CouponGiftCard, Donations, PayableCard, PaymentForm, CartDiscardTimeInfo,
    DonationPopUp, MembershipPackagesCard, GATicketCard, GiftCards,
    OrderItemsCard, DonationProductCard
} from './components';

import {
    actionShopCartResetStateWithTourHold, actionResetFieldValuesState, actionResetBookingTypes, actionResetCustomerUdfs,
    actionShopCartAddProductQuanityWithTourHold, actionResetDonations, actionResetTransactionFee, actionValidateRecaptchaReset,
    actionShopCartRemoveTourWithTourHold, actionResetBooking, actionResetGiftCards, actionResetMembershipPackages,
    actionShopCartResetStateWithUniqueCouponHold, actionResetCostRate, actionResetIDMEUSERDATA, actionResetUDFs,
    actionShopCartResetMembership, actionShopCartResetIDME, actionShopCartResetMembershipPackage, actionResetMembershipUDFs,
    actionShopCartRemoveGATicket, actionShopCartGATicketUpdateQuanity, actionShopCartResetGATicket, actionShopCartRemoveGiftcards,
    actionDeleteOrderProduct, actionShopcartResetOrderProducts, actionShopCartResetDonation, actionShopCartApplyDonation,
    actionShopCartDeleteDonationProduct, actionShopCartResetDonationProduct, actionResetMemberValidation,
    actionShopCartResetDonations, actionResetCustomerAddresses, actionResetCustomer, actionResetExtraItems
} from 'actions';

const { ApplyTransactionFee, ShowDonationPopUp, HideCoupons, HideGiftCards } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
    closebutton: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    DialogeHeader: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.success.contrastText
    },
    DialogeHeaderText: {
        color: theme.palette.success.contrastText
    },
    hidden: {
        visibility: "hidden"
    },
    paymentbox: {
        height: "100%"
    },
    linkbutton: {
        padding: "0px 5px 0px 0px"
    },
    diplaynone: {
        display: 'none'
    }
}));

const Checkout = (props) => {

    const gatewayRef = useRef();
    const classes = useStyles();

    const events = useSelector(state => state.reducerShopCart.events);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    const gaTickets = useSelector(state => state.reducerShopCart.GATickets);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const orderLocation = useSelector(state => state.reducerOrderLocations.orderLocation);
    const shopcartreducer = useSelector(state => state.reducerShopCart);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const bookingUDFS = useSelector(state => state.reducerBookingUserDefinedFields);
    const membershipTypesUdfs = useSelector(state => state.reducerMembershipUserDefinedFields);
    const customerUdfs = useSelector(state => state.reducerCustomerUDFs);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);
    const donations = useSelector(state => state.reducerDonation);
    const customerAddresses = useSelector(state => state.reducerCustomerAddresses.customerAddresses);
    const customer = useSelector(state => state.reducerCustomer);

    const [opendonationPopup, setopendonationPopup] = useState(true);

    const CloseDonationPopUp = () => {
        setopendonationPopup(false);
    }

    const ApplyDonation = (productID, productName, price, OthersAmount) => {

        let useAltMerchant = false;

        if (donations.donations && donations.donations.length > 0) {
            useAltMerchant = donations.donations[0].UseAlternateMerchantOnline
        }

        actionShopCartApplyDonation(dispatch, productID, productName, price, OthersAmount, useAltMerchant);
    }
    const paymenttranstate = useSelector(state => {
        return (
            {
                haspaid: state.reducerPaymentTransaction.Payment.hasOwnProperty('Products')
            }
        )
    });

    const dispatch = useDispatch();

    useEffect(() => {

        if ((events && events.length === 0) && (membershipPackages && membershipPackages.length == 0) && gaTickets && gaTickets.length == 0 && giftcards.giftcards && giftcards.giftcards.length == 0 && donationProducts && donationProducts.length == 0) {

            actionResetFieldValuesState(dispatch);
            actionResetTransactionFee(dispatch);
            actionShopCartResetMembership(dispatch);
            actionShopCartResetIDME(dispatch);

            if (shopcartreducer.membershipValidation.ismembershipApplied) {
                actionResetMemberValidation(dispatch);
            }
        }

    }, [events, membershipPackages, gaTickets, giftcards.giftcards, donationProducts])

    const removeclickhandler = (eventid, productid) => {
        actionShopCartRemoveTourWithTourHold(dispatch, events, eventid, productid)
    }

    const changeQuantityHandler = (reference, quantity) => {
        actionShopCartAddProductQuanityWithTourHold(dispatch, events, reference.eventId, reference.tourProductID, quantity);
    }

    const removeGATicketClickHandler = (ProductId) => {
        actionShopCartRemoveGATicket(dispatch, ProductId)
    }

    const removeOrderProductClickHandler = (product) => {
        actionDeleteOrderProduct(dispatch, product);
    }

    const changeGATicketQuantityHandler = (reference, quantity) => {
        actionShopCartGATicketUpdateQuanity(dispatch, reference.tourProductID, quantity);
    }

    const remoteDonationProductClickHandler = (productID) => {
        actionShopCartDeleteDonationProduct(dispatch, productID);
    }

    const goBack = () => {

        if (events && events.length > 0) {
            props.history.push('/products');
            return;
        }

        if (membershipPackages && membershipPackages.length > 0) {
            props.history.push('/memberships');
            return;
        }

        else if (gaTickets && gaTickets.length > 0) {
            props.history.push('/gatickets');
            return;
        }

        else if (donationProducts && donationProducts.length > 0) {
            props.history.push('/donation/Area/' + donationProducts[donationProducts.length - 1].DisplayArea);
            return;
        }

        else if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            props.history.push('/giftcards');
            return;
        }

        else if (orderProducts && orderProducts.length > 0) {
            if (orderLocation) {
                let tabLocationID = orderLocation.TabLocations[0].TabLocationID;
                props.history.push('/ordermenu/' + tabLocationID);
            }
            else {
                actionShopcartResetOrderProducts(dispatch);
                props.history.push('/orderlocation');
            }
            return;
        }
    }

    const ShowGiftCards = () => {
        let res = false;
        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.filter(x => x.AddedToCart === true).length > 0) {
                res = true;
            }
        }

        return res;
    }


    let displayclass = "";
    if (paymenttranstate.haspaid)
        displayclass = classes.hidden;

    return (
        <Container className={classes.root}>
            {ShowDonationPopUp ? <DonationPopUp showDialog={opendonationPopup} CloseDonationPopUp={CloseDonationPopUp} ApplyDonation={ApplyDonation}></DonationPopUp> : null}
            <Typography variant="h1" component="h1" color="primary"
                style={{ paddingBottom: 15, textAlign: "center" }}>Checkout</Typography>
            <Grid
                container
                spacing={1}>
                <Grid container item justify="center" xs={12}>
                    {(events && events.length > 0)
                        || (membershipPackages && membershipPackages.length > 0)
                        || (gaTickets && gaTickets.length > 0)
                        || (orderProducts && orderProducts.length > 0)
                        || (donationProducts && donationProducts.length > 0)
                        || ShowGiftCards() ?
                        <Grid item sm={6} md={6} >
                            <Link component="button" variant="h5" color="primary" className={classes.linkbutton}
                                onClick={() => {
                                    actionResetExtraItems(dispatch);
                                    goBack()
                                }}
                            >
                                Continue Shopping
                            </Link>

                            <Link component="button" className={classes.linkbutton} variant="h5"
                                color="error"
                                onClick={() => {

                                    if (events && events.length > 0) {
                                        actionShopCartResetStateWithTourHold(dispatch, events);
                                    }

                                    if (shopcartreducer.donation.isdonationApplied) {
                                        actionShopCartResetDonation(dispatch);
                                    }

                                    if (shopcartreducer.tourCoupons.length > 0) {
                                        actionResetDonations(dispatch);
                                        actionShopCartResetStateWithUniqueCouponHold(dispatch);
                                    }

                                    if (shopcartreducer.cashless.length > 0) {
                                        actionShopCartRemoveGiftcards(dispatch);
                                    }

                                    actionResetMemberValidation(dispatch);
                                    actionResetFieldValuesState(dispatch);
                                    actionResetBookingTypes(dispatch);
                                    actionShopCartResetMembershipPackage(dispatch);
                                    actionResetExtraItems(dispatch);
                                    actionResetMembershipPackages(dispatch);
                                    actionShopCartResetMembership(dispatch);
                                    actionShopCartResetIDME(dispatch);

                                    if (ApplyTransactionFee) {
                                        actionResetTransactionFee(dispatch);
                                    }

                                    actionShopCartResetGATicket(dispatch);
                                    actionShopCartResetDonationProduct(dispatch);
                                    actionShopcartResetOrderProducts(dispatch);
                                    actionResetBooking(dispatch);
                                    actionResetGiftCards(dispatch);
                                    actionResetCostRate(dispatch);
                                    actionResetIDMEUSERDATA(dispatch);

                                    if (bookingUDFS.bookingUDFs.length > 0) {
                                        actionResetUDFs(dispatch);
                                    }

                                    if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {
                                        actionResetMembershipUDFs(dispatch);
                                    }

                                    if (customerUdfs.customerUDFs && customerUdfs.customerUDFs.length > 0) {
                                        actionResetCustomerUdfs(dispatch);
                                    }

                                    if (customerAddresses && customerAddresses.length > 0) {
                                        actionResetCustomerAddresses(dispatch);
                                    }

                                    if (customer.customer && customer.customer.length > 0) {
                                        actionResetCustomer(dispatch);
                                    }

                                    gatewayRef.current.ReloadGateways();

                                    actionShopCartResetDonations(dispatch);

                                    setTimeout(() => {
                                        actionValidateRecaptchaReset(dispatch);
                                    }, 1000)

                                }}
                            >
                                Clear Cart
                            </Link>
                        </Grid>
                        : ""}
                    <Grid container item justify={window.matchMedia("(max-width: 450px)").matches ? "center" : "flex-end"} sm={6} md={6} >
                        <Grid item>
                            <CartDiscardTimeInfo ></CartDiscardTimeInfo>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item xs={12} md={6} className={displayclass} spacing={1}>
                    {events && events.length > 0 ?
                        <Grid item xs={12}>
                            <BookingTypeCard products={events} removeclickhandler={removeclickhandler} changeQuantityHandler={changeQuantityHandler} />
                        </Grid> : null}

                    {gaTickets && gaTickets.length > 0 ?
                        <Grid item xs={12}>
                            <GATicketCard products={gaTickets} removeclickhandler={removeGATicketClickHandler} changeQuantityHandler={changeGATicketQuantityHandler} />
                        </Grid>
                        : null}

                    {orderProducts && orderProducts.length > 0 ?
                        <Grid item xs={12}>
                            <OrderItemsCard products={orderProducts} removeclickhandler={removeOrderProductClickHandler} />
                        </Grid> : null}
                    {donationProducts && donationProducts.length > 0 ? <Grid item xs={12}>
                        <DonationProductCard products={donationProducts} removeclickhandler={remoteDonationProductClickHandler}></DonationProductCard>
                    </Grid> : null}


                    <Grid item xs={12} className={ShowGiftCards() && !HideGiftCards ? '' : classes.diplaynone}>
                        <GiftCards />
                    </Grid>

                    <Grid item xs={12} className={membershipPackages && membershipPackages.length > 0 ? '' : classes.diplaynone}>
                        <MembershipPackagesCard membershipPackages={membershipPackages} />
                    </Grid>


                    <Grid item xs={12} className={(events && events.length > 0 && !HideCoupons) || (membershipPackages && membershipPackages.length > 0) || (gaTickets && gaTickets.length > 0) || (orderProducts && orderProducts.length > 0) || (donationProducts && donationProducts.length > 0) || ShowGiftCards() ? '' : classes.diplaynone}>
                        <CouponGiftCard />
                    </Grid>



                    <Grid item xs={12} className={paymenttranstate.haspaid ? classes.diplaynone : ''} >
                        <PayableCard products={events} membershipPackages={membershipPackages} cashless={cashless} gatickets={gaTickets} orderProducts={orderProducts} donationProducts={donationProducts} />
                    </Grid>


                    <Grid item xs={12} className={(events && events.length > 0) || (membershipPackages && membershipPackages.length > 0) || (gaTickets && gaTickets.length > 0) || (orderProducts && orderProducts.length > 0) || (donationProducts && donationProducts.length > 0) || ShowGiftCards() ? '' : classes.diplaynone}>
                        <Donations ApplyDonation={ApplyDonation} />
                    </Grid>

                </Grid>
                <Grid item md={6} xs={12}>
                    <Grid item xs={12} className={classes.paymentbox}>
                        <PaymentForm events={events} history={props.history} ref={gatewayRef} />
                    </Grid>
                </Grid>
            </Grid>
        </Container >
    );
};

export default Checkout;
